import { takeEvery, put, call } from "redux-saga/effects";

// Login Redux States
import {
  ADD_EMPLOYEE,
  GET_STAFF,
  GET_STAFF_BY_EMAIL,
  DELETE_STAFF,
  GET_STAFF_BY_ID,
  UPDATE_EMPLOYEE,
  GET_STAFF_CALENDER,
  POST_STAFF_DOC,
  STAFF_STATE,
  GET_EMPLOYEE_PROFILE_DOCS,
  APPROVE_EMP_DOCS,
  NOTIFY_EMPLOYEE,
  EMPLOYEES_EXPIRE_DOCS_LIST,
  AVAILABILITY,
  DELETE_STAFF_DOC,
  COPY_EMPLOYEE_PROFILE,
  GENERATE_TIME_SHEET,
  GET_ADMIN_TIMESHEET_LIST,
  SEND_TIME_SHEET_TO_SUPPORT_WORKER,
  SAVE_TIME_SHEET_SUCCESS,
  SAVE_TIME_SHEET,
  RE_SUBMIT_TIME_SHEET,
  REMOVE_TIME_SHEET,
  APPROVE_EMP_VEHICLE_DOCS,
  GET_EMPLOYEE_RATING_REPORT,
  DELETE_TRAINING_DOC,
} from "./actionTypes";

import {
  addEmployeeSuccess,
  addEmployeeFail,
  getStaffSuccess,
  getStaffFail,
  postDeleteStaffSuccess,
  postDeleteStaffFail,
  getStaffDetailSuccess,
  getStaffDetailFail,
  updateEmployeeSuccess,
  updateEmployeeFail,
  getStaffByEmailSuccess,
  getStaffByEmailFail,
  getStaffCalDataSuccess,
  getStaffCalDataFail,
  postStaffdocSuccess,
  postStaffdocFail,
  StaffStateSuccess,
  StaffStateFail,
  getEmpProfileDocsSuccess,
  getEmpProfileDocsFail,
  approveEmpDocFail,
  approveEmpDocSuccess,
  notifyEmployeeFail,
  notifyEmployeeSuccess,
  getEmployeesExpDocsFail,
  getEmployeesExpDocsSuccess,
  myAvailabiliesSuccess,
  myAvailabiliesFail,
  deleteStaffDocumentSuccess,
  deleteStaffDocumentFail,
  getStaffDetail,
  copyEmpProfileSuccess,
  copyEmpProfileFail,
  generateTimeSheetSuccess,
  generateTimeSheetFail,
  getAdminTimeSheetListSuccess,
  getAdminTimeSheetListFail,
  sendTimeSheeToSupportWorkerSuccess,
  sendTimeSheeToSupportWorkerFail,
  reSubmitTimeSheetSuccess,
  reSubmitTimeSheetFail,
  removeTimeSheetSuccess,
  removeTimeSheetFail,
  approveEmpVehicleDocSuccess,
  approveEmpVehicleDocFail,
  employeeRatingReportSuccess,
  employeeRatingReportFail,
  deleteTrainingDocSuccess,
  deleteTrainingDocFailure,
} from "./actions";

import {
  addEmployee,
  getAllStaff,
  deleteStaff,
  getStaffById,
  postUpdateStaff,
  getStaffByEmail,
  staffCalenderData,
  postStaffDocuments,
  changeStaffState,
  employeeProfileDocs,
  employeeDocApproval,
  notifyEmployeeForDocs,
  employeesExpDocsList,
  onGetAvailability,
  onDeletingStaffDocument,
  onCopyingEmpProfile,
  onGeneratingTimeSheet,
  onGettingTimeSheetList,
  onSendingTimeSheet,
  onReSubmittingTimeSheet,
  onRemovingTimeSheet,
  employeeVehicleDocApproval,
  onGetEmployeeRatingReport,
  onRemovingTrainingDocs,
} from "helpers/fakebackend_helper";

import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

function* onDeleteDocument({ payload: { data, dispatch } }) {
  try {
    const response = yield call(onDeletingStaffDocument, data);
    if (response.status) {
      yield put(deleteStaffDocumentSuccess(response));
      showToast("success", "Staff", response.message);
      dispatch(getStaffDetail({ id: data?.staff_id }));
    } else {
      yield put(deleteStaffDocumentFail(response));
      showToast("warning", "Staff", response.message);
    }
  } catch (error) {
    yield put(deleteStaffDocumentFail(error));
    showToast("error", "Staff", error);
  }
}

function* Set_Staff_State({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(changeStaffState, data);
    yield call(responseHandler, "Participant", response, StaffStateSuccess, StaffStateFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(StaffStateFail(error));
  }
}

function* onGenerateTimeSheet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGeneratingTimeSheet, data);
    yield call(responseHandler, "Time Sheet", response, generateTimeSheetSuccess, generateTimeSheetFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(generateTimeSheetFail(error));
  }
}

function* onGettingAvailabilities({ payload: data }) {
  try {
    const response = yield call(onGetAvailability, data);
    if (response.status) {
      yield put(myAvailabiliesSuccess(response));
    } else {
      yield put(myAvailabiliesFail(response));
      showToast("warning", "Availability", response.message);
    }
  } catch (error) {
    yield put(myAvailabiliesFail(error));
    showToast("error", "Availability", error);
  }
}

function* Notify_Employee_Docs({ payload: data }) {
  try {
    const response = yield call(notifyEmployeeForDocs, data);
    yield put(notifyEmployeeSuccess(response));
    if (response?.status) showToast("success", "Employee Documents", response.message);
  } catch (error) {
    yield put(notifyEmployeeFail(error));
    showToast("error", "Employee Documents", error);
  }
}

function* Approve_Employee_Doc({ payload: data }) {
  try {
    const response = yield call(employeeDocApproval, data);
    yield put(approveEmpDocSuccess(response));
    if (response?.status) showToast("success", "Employee Documents", response.message);
  } catch (error) {
    yield put(approveEmpDocFail(error));
    showToast("error", "Employee Documents", error);
  }
}

function* Approve_Employee_Vehicle_Doc({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(employeeVehicleDocApproval, data);
    yield call(responseHandler, "Employee Documents", response, approveEmpVehicleDocSuccess, approveEmpVehicleDocFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(approveEmpVehicleDocFail(error));
    showToast("error", "Employee Documents", error);
  }
}

function* Employee_Profile_Documents({ payload: user }) {
  try {
    const response = yield call(employeeProfileDocs, user);
    if (response?.documents_data?.user_token) {
      localStorage.setItem("uid", JSON.stringify(response?.documents_data?.user_token));
    } else {
      localStorage.removeItem("uid");
    }
    yield put(getEmpProfileDocsSuccess(response));
  } catch (error) {
    yield put(getEmpProfileDocsFail(error));
    showToast("error", "Employee Documents", error);
  }
}

function* onUpdate({ payload: { user, onSuccess, onError } }) {
  try {
    const response = yield call(postUpdateStaff, user);
    yield call(responseHandler, "Employee", response, updateEmployeeSuccess, updateEmployeeFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateEmployeeFail(error));
    showToast("error", "Staff", error);
  }
}

function* Post_StaffByID({ payload: id }) {
  try {
    const response = yield call(getStaffById, id);
    yield put(getStaffDetailSuccess(response));
  } catch (error) {
    yield put(getStaffDetailFail(error));
  }
}

function* Exp_Docs_List_Employee({ payload: data }) {
  try {
    const response = yield call(employeesExpDocsList, data);
    yield put(getEmployeesExpDocsSuccess(response));
  } catch (error) {
    yield put(getEmployeesExpDocsFail(error));
  }
}

function* onAddingEmployee({ payload: { user, onSuccess, onError } }) {
  try {
    const response = yield call(addEmployee, user);
    yield call(responseHandler, "Employee", response, addEmployeeSuccess, addEmployeeFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addEmployeeFail(error));
    showToast("error", "Staff", error);
  }
}

function* Get_AllStaff({ payload: data }) {
  try {
    const response = yield call(getAllStaff, data);
    yield put(getStaffSuccess(response));
  } catch (error) {
    yield put(getStaffFail(error));
  }
}

function* Post_DeleteStaff({ payload: id }) {
  try {
    const response = yield call(deleteStaff, id);
    yield put(postDeleteStaffSuccess(response));
    showToast("success", "Staff", "Deleted Successfully.");
  } catch (error) {
    yield put(postDeleteStaffFail(error));
    showToast("error", "Staff", error);
  }
}

export function* Get_StaffByEmail({ payload: user }) {
  try {
    const response = yield call(getStaffByEmail, user);
    yield put(getStaffByEmailSuccess(response));
  } catch (error) {
    yield put(getStaffByEmailFail(error));
  }
}

export function* fetchStaffCalData({ payload: data }) {
  try {
    const response = yield call(staffCalenderData, data);
    yield put(getStaffCalDataSuccess(response));
  } catch (error) {
    yield put(getStaffCalDataFail(error));
  }
}

export function* staff_docs({ payload: data }) {
  try {
    const response = yield call(postStaffDocuments, data);
    yield put(postStaffdocSuccess(response));
    showToast("success", "Staff", "Uploaded Successfully.");
  } catch (error) {
    yield put(postStaffdocFail(error));
    showToast("error", "Staff", error);
  }
}

function* onCopyEmp({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onCopyingEmpProfile, data);
    yield call(responseHandler, "Adding Employing", response, copyEmpProfileSuccess, copyEmpProfileFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(copyEmpProfileFail(error));
    showToast("error", "Staff", error);
  }
}

function* onGetTimeSheetList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTimeSheetList, data);
    yield call(responseHandler, "Adding Employing", response, getAdminTimeSheetListSuccess, getAdminTimeSheetListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getAdminTimeSheetListFail(error));
    showToast("error", "Staff", error);
  }
}

function* onSendTimeSheet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSendingTimeSheet, data);
    yield call(responseHandler, "Sending", response, sendTimeSheeToSupportWorkerSuccess, sendTimeSheeToSupportWorkerFail, onSuccess, onError);
  } catch (error) {
    console.log(error);
    onError();
    yield put(sendTimeSheeToSupportWorkerFail(error));
  }
}

function* onReSubmitTimeSheet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onReSubmittingTimeSheet, data);
    yield call(responseHandler, "Sending", response, reSubmitTimeSheetSuccess, reSubmitTimeSheetFail, onSuccess, onError);
  } catch (error) {
    onError();
    console.log(error);
    yield put(reSubmitTimeSheetFail(error));
  }
}

function* onRemoveTimeSheet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRemovingTimeSheet, data);
    yield call(responseHandler, "Removing", response, removeTimeSheetSuccess, removeTimeSheetFail, onSuccess, onError);
  } catch (error) {
    onError();
    console.log(error);
    yield put(removeTimeSheetFail(error));
  }
}

function* onEmployeeRatingReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGetEmployeeRatingReport, data);
    yield call(responseHandler, "Employee Report", response, employeeRatingReportSuccess, employeeRatingReportFail, onSuccess, onError);
  } catch (error) {
    onError();
    console.log(error);
    yield put(employeeRatingReportFail(error));
  }
}
function* deleteTrainingDoc({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRemovingTrainingDocs, data);
    yield call(responseHandler, "Training Docs", response, deleteTrainingDocSuccess, deleteTrainingDocFailure, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteTrainingDocFailure(error));
  }
}

export function* Staff() {
  yield takeEvery(GET_EMPLOYEE_RATING_REPORT, onEmployeeRatingReport);
  yield takeEvery(APPROVE_EMP_VEHICLE_DOCS, Approve_Employee_Vehicle_Doc);
  yield takeEvery(REMOVE_TIME_SHEET, onRemoveTimeSheet);
  yield takeEvery(RE_SUBMIT_TIME_SHEET, onReSubmitTimeSheet);
  yield takeEvery(SEND_TIME_SHEET_TO_SUPPORT_WORKER, onSendTimeSheet);
  yield takeEvery(GET_ADMIN_TIMESHEET_LIST, onGetTimeSheetList);
  yield takeEvery(COPY_EMPLOYEE_PROFILE, onCopyEmp);
  yield takeEvery(GENERATE_TIME_SHEET, onGenerateTimeSheet);
  yield takeEvery(UPDATE_EMPLOYEE, onUpdate);
  yield takeEvery(ADD_EMPLOYEE, onAddingEmployee);
  yield takeEvery(GET_STAFF, Get_AllStaff);
  yield takeEvery(DELETE_STAFF, Post_DeleteStaff);
  yield takeEvery(GET_STAFF_BY_ID, Post_StaffByID);
  yield takeEvery(GET_STAFF_BY_EMAIL, Get_StaffByEmail);
  yield takeEvery(GET_STAFF_CALENDER, fetchStaffCalData);
  yield takeEvery(POST_STAFF_DOC, staff_docs);
  yield takeEvery(STAFF_STATE, Set_Staff_State);
  yield takeEvery(GET_EMPLOYEE_PROFILE_DOCS, Employee_Profile_Documents);
  yield takeEvery(APPROVE_EMP_DOCS, Approve_Employee_Doc);
  yield takeEvery(NOTIFY_EMPLOYEE, Notify_Employee_Docs);
  yield takeEvery(EMPLOYEES_EXPIRE_DOCS_LIST, Exp_Docs_List_Employee);
  yield takeEvery(AVAILABILITY, onGettingAvailabilities);
  yield takeEvery(DELETE_STAFF_DOC, onDeleteDocument);
  yield takeEvery(DELETE_TRAINING_DOC, deleteTrainingDoc);
}

export default Staff;
